import { Container, Row, Col, Nav, Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch} from 'react-redux';
import { addItem } from '../store';


function Detail(props){
  let {id} =useParams();
  let [tab,setTab] =useState(0);
  let selproduct=props.shoes.find((x)=>x.id==id);
  let dispatch=useDispatch();

  let [alert,setAlert] =useState(true);

  useEffect(()=>{
    setTimeout(()=>{ setAlert(false) }, 2000)
    }, [tab])

  return(
    <>
      <Container>
        {
          alert===true
          ?<alert variant='warning'>
            2초 이내 구매시 할인
          </alert>
          :null
        }
      
        <Row>
          <Col md={6}>
            <img src={"/img/shoes" + (Number(id) + 1) + ".jpg"} width="100%" alt='product' />
          </Col>
          <Col md={6}>
            <h4 className="pt-5">{selproduct.title}</h4>
            <p>{selproduct.content}</p>
            <p>{selproduct.price}</p>
            <Button className="btn btn-danger" onClick={()=>{
              dispatch(addItem({id:selproduct.id, name:selproduct.title, count:1}))
            }}>주문하기</Button>
          </Col>
        </Row>
      </Container>

      <Nav variant="tabs" defaultActiveKey="/home">
        <Nav.Item>
          <Nav.Link eventKey="link-0" onClick={()=>{setTab(0)}}>Option 1</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="link-1" onClick={()=>{setTab(1)}}>Option 2</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="link-2" onClick={()=>{setTab(2)}}>Option 3</Nav.Link>
        </Nav.Item>
      </Nav>

      {
        (()=>{
          if(tab===0){
            return <div>내용1</div>
          }else if(tab===1){
            return <div>내용2</div>
          }else if(tab===2){
            return <div>내용3</div>  
          }
        })()
      }

      
      
      
    </>
    // <TabContent tab={tab}/>
  )
}

function TabContent({tab}){
  let[fade, setFade]= useState("")

  useEffect(()=>{
      setTimeout(()=>{setFade('end')},50)
      return ()=>{
        setFade("");
      }
  },[tab])
  return(
    <div className={'start'+fade}>
      {[<div>내용0</div>, <div>내용1</div>, <div>내용2</div>][tab]}
    </div>
  )
}

export default Detail;
